<template>
  <Dialog v-model="visible">
    <div class="daily-dice-dialog">
      <div class="tip-line">
        {{ $t('monopoly.dailyDiceTipPrefix') }}<span class="num-green">{{ props.maxTotal }}</span>{{ $t('monopoly.dailyDiceTipSuffix') }}
      </div>
      <div class="remain-line">
        {{ $t('monopoly.dailyDiceRemainPrefix') }}<span class="num-orange">{{ remainCount }}</span>
      </div>
      <div class="dice-wrap">
        <img
          class="dice-img"
          src="@/views/act/monopoly/assets/img/normal-dice.png"
          alt="dice"
        >
      </div>
      <Btn
        type="blue"
        class="claim-btn"
        :disabled="claiming"
        @click="handleClaim"
      >
        {{ $t('monopoly.dailyDiceClaim') }}
      </Btn>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import Dialog from '../Dialog/index.vue'
import Btn from '../Btn/index.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  claimedTotal: {
    type: Number,
    default: 0,
  },
  maxTotal: {
    type: Number,
    default: 3,
  },
  claiming: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'claim'])

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

const remainCount = computed(() =>
  Math.max(0, props.maxTotal - Number(props.claimedTotal || 0))
)

const handleClaim = () => {
  if (props.claiming) return
  emit('claim')
}
</script>

<style lang="less" scoped>
.daily-dice-dialog {
  width: 100%;
  text-align: center;
  color: #333333;
}

.tip-line,
.remain-line {
  font-size: 28px;
  line-height: 1.55;
  font-weight: 600;
}

.remain-line {
  margin-top: 10px;
}

.num-green {
  color: #3fd33a;
  font-weight: bold;
}

.num-orange {
  color: #ff9a1a;
  font-weight: bold;
}

.dice-wrap {
  margin: 36px auto 40px;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle, #fff4b8 0%, rgba(255, 244, 184, 0.35) 55%, transparent 75%);
  border-radius: 50%;
}

.dice-img {
  width: 130px;
  height: auto;
}

.claim-btn {
  margin: 0 auto;
}
</style>
